<template>
  <div class="header">
    <b-row v-if="company">
      <b-col md="3">
      
        <h4>{{company.name}} <b-badge v-if="company.isAVL" variant="success">AVL</b-badge>   </h4> 
        
        
        <div class="col-form-label">
          <star-rating
            :star-size="20"
            :increment="0.5"
            :read-only="true"
            :show-rating="false"
            v-model="company.overallRating"
          ></star-rating>
        </div>
        <div class="mt-3">
          <span class="badge badge-pill badge-primary even-larger-badge mr-2"
            v-for="(selectAttr, indexAttr) in selectedAttributes" :key="indexAttr">{{ selectAttr }}
          </span>  
        </div>      
      </b-col>
      <b-col md="9">
        <b-row>
          <b-col md="2">
            <div class="form-group row">
              <label class="col-sm-5 col-form-label text-right">Type:</label>
              <label class="col-sm-7 col-form-label text-dark">{{company.accountTypeNames}}</label>
            </div>
          </b-col>
          <b-col md="3">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label text-right">Sales Rep:</label>
              <label class="col-sm-8 col-form-label text-dark">{{company.salesPerson1FullName}}</label>
            </div>
          </b-col>
          <b-col md="3">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label text-right">Scope:</label>
              <label class="col-sm-10 col-form-label text-dark">{{company.scope}}</label>
            </div>
          </b-col>
          <b-col md="3">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label text-right">Time:</label>
              <label class="col-sm-10 col-form-label text-dark">{{timezone}}</label>
            </div>
          </b-col>
          <b-col md="1">
            <b-link @click="goBackNavigation" class="btn close" style="padding: 0 !important">
              <i class="fa fa-times" aria-hidden="true"></i>
            </b-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <div class="form-group row">
              <label class="col-sm-5 col-form-label text-right">Account #:</label>
              <label class="col-sm-7 col-form-label text-dark">{{company.id}}</label>
            </div>
          </b-col>
          <b-col md="3">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label text-right">Alt Sales Rep:</label>
              <label class="col-sm-8 col-form-label text-dark">{{company.salesPerson2FullName || '-'}}</label>
            </div>
          </b-col>
          <b-col md="3" >
            <div class="form-group row">
              <label class="col-sm-2 col-form-label text-right">VType:</label>
              <label class="col-sm-10 col-form-label text-dark text-break">{{ (isVendor) ? company.vendorTypeName || '-' : 'N/A' }}</label>
            </div>
          </b-col>
          <b-col md="3">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label text-right">Class:</label>
              <label class="col-sm-10 col-form-label text-dark">{{company.accountClassName || '-'}}</label>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <div class="form-group row">
              <label class="col-sm-5 col-form-label text-right">Source:</label>
              <label class="col-sm-7 col-form-label text-dark">{{company.referralSource}}</label>
            </div>
          </b-col>
          <b-col md="3">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label text-right">Buyers Rep:</label>
              <label class="col-sm-8 col-form-label text-dark">{{company.buyer1UserFullName}}</label>
            </div>
          </b-col>
          <b-col md="3">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label text-right">SIC:</label>
              <label class="col-sm-10 col-form-label text-dark">{{company.sicCode}}</label>
            </div>
          </b-col>
          <b-col md="2">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label text-right">NAICS:</label>
              <label class="col-sm-9 col-form-label text-dark">{{company.naicsCode}}</label>
            </div>
          </b-col>
          <b-col md="2">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label text-right">D&B:</label>
              <label class="col-sm-9 col-form-label text-dark">{{company.dunAndBradstreet}}</label>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col offset="9">
            <div style="display: inline-block" class="pull-right mt-2">
              <edit-company :id="$route.params.id" isToRedirect></edit-company>
              <b-button variant="primary" size="sm" @click="onSaveToQbo" :disabled="isSavingQbo" v-if="company != null && !isCompanyQBO" class="ml-2">
                <i class="fa fa-book mr-2" aria-hidden="true"></i>Send to QBO
              </b-button>
            </div>
            
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import StarRating from 'vue-star-rating';
import EditCompany from '@/pages/Company/components/EditCompany';
import { sortAttributes } from '@/shared/helpers';

export default {
  components: {
    StarRating,
    EditCompany,
  },
  name: 'Header',
  data() {
    return {
      timezone: null,
      selected: null,
      selectedAttributes: [],
      filteredAttributes: [],
      isSavingQbo: false,
    };
  },
  watch: {
    company: function(company) {
      this.timezone = this.returnTimezoneName(this.company.timezoneId);
      this.loadCompanyAttributes(company);
    },
  },
  props: ['companyId', 'isVendor', 'company'],
  computed: {
    // ...mapGetters('companies', ['companyById']),
    // company() {
    //   return this.companyById(this.companyId);
    // },
    ...mapState('lookup', ['attributes']),
    ...mapState('timezones', ['timezones']),
    isCompanyQBO() {
      if (this.company != null) {
        let accountTypes = this.company.account_AccountTypes;

        return accountTypes.filter(x => x.qbId != null).length > 0;
      } else {
        return null;
      }
    },
    routeQuery() {
      return this.$route.query;
    }
  },
  methods: {
    ...mapActions('timezones', ['getTimezones']),
    ...mapActions('companies', ['saveCompanyToQbo']),
    returnTimezoneName(id) {
      if (!id || !this.timezones || this.timezones.length == 0) return '';

      const result = this.timezones.filter(x => x.id == id);

      return result[0].timeZoneName || null;
    },
    loadCompanyAttributes(company) {
      let companyAttributes = company.accountAttributes.map(
        element => element.attributeId
      );
      this.selectedAttributes = this.attributes.filter(x => companyAttributes.includes(x.id)).map(x => x.name);
    },
    async onSaveToQbo() {
      this.isSavingQbo = true;
      const result = await this.saveCompanyToQbo(this.companyId).catch(() => this.isSavingQbo = false);
      if (result.status == 200) {
        this.$snotify.success('Successfully saved to Quickbooks');
      }
      this.isSavingQbo = false;
    },
    goBackNavigation() {
      if (this.routeQuery.listPage) {
        this.$router.push({
          name: this.routeQuery.listPage
        });
      } else { 
        this.$router.push(`/company`);
      }
    }
  },
  mounted() {
    // this.filteredAttributes = sortAttributes(this.attributes);
    this.loadCompanyAttributes(this.company);
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';
.header {
  &--title {
    margin-right: 1rem;
  }
}

.no-margin-bottom {
  .form-group {
    margin-bottom: 0;
  }
}
.info-label {
  font-size: 12px;
    font-weight: bold;
    color: $mutedGray;
}
.info-value {
    font-size: 12px;
    font-weight: bold;
    color: #000;
}

.even-larger-badge {
  font-size: 1.2em;
}
</style>
